import { CONTENT_CATEGORIES } from "@/data/curatedContent";

interface CategoryFilterBarProps {
  activeCategory: string | null;
  onCategoryChange: (category: string | null) => void;
}

export function CategoryFilterBar({ activeCategory, onCategoryChange }: CategoryFilterBarProps) {
  return (
    <div
      className="w-full overflow-x-auto scrollbar-hide"
      style={{ height: 48, marginBottom: 24 }}
    >
      <div className="flex items-center justify-center" style={{ gap: 24 }}>
        <button
          onClick={() => onCategoryChange(null)}
          className="whitespace-nowrap shrink-0 text-foreground transition-colors relative"
          style={{ fontSize: 15, padding: "8px 0" }}
        >
          All
          {activeCategory === null && (
            <span
              className="absolute left-0 right-0 bottom-0 bg-foreground"
              style={{ height: 2, bottom: -8 }}
            />
          )}
        </button>
        {CONTENT_CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => onCategoryChange(activeCategory === cat ? null : cat)}
            className={`whitespace-nowrap shrink-0 transition-colors relative ${
              activeCategory === cat
                ? "text-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
            style={{ fontSize: 15, padding: "8px 0" }}
          >
            {cat}
            {activeCategory === cat && (
              <span
                className="absolute left-0 right-0 bg-foreground"
                style={{ height: 2, bottom: -8 }}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
